export default __webpack_public_path__ + "reverse-800-56993e8ecefc64e5e92d62395333b581.png";